// Tailwind class mapping for the 14+ complaint statuses
export const STATUS_STYLES = {
  "New Complaint": "bg-blue-100 text-blue-700 border-blue-200",
  "Warranty Verification": "bg-lime-100 text-lime-800 border-lime-200",
  "Assign to Tech": "bg-cyan-100 text-cyan-700 border-cyan-200",
  "Pending": "bg-yellow-100 text-yellow-800 border-yellow-200",
  "Parts Pending": "bg-orange-100 text-orange-800 border-orange-200",
  "PNA": "bg-rose-100 text-rose-700 border-rose-200",
  "Parts Approved": "bg-green-100 text-green-800 border-green-200",
  "Parts in Transit": "bg-amber-100 text-amber-800 border-amber-200",
  "Parts Sent": "bg-amber-50 text-amber-700 border-amber-200",
  "Received by Technician": "bg-teal-50 text-teal-700 border-teal-200",
  "Request to Close": "bg-sky-100 text-sky-800 border-sky-200",
  "Request to Close - Pending Service Manager Verification": "bg-indigo-100 text-indigo-800 border-indigo-200",
  "Rejected by Service Manager": "bg-rose-100 text-rose-800 border-rose-200",
  "Pending CCR Happy Call": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Customer Not Satisfied / Reopened": "bg-rose-50 text-rose-700 border-rose-200",
  "Pending Service Head Closure": "bg-violet-100 text-violet-800 border-violet-200",
  "Duplicate Review Required": "bg-amber-100 text-amber-800 border-amber-200",
  "Closed": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Cancelled": "bg-slate-100 text-slate-700 border-slate-200",
  "Exchange": "bg-indigo-100 text-indigo-700 border-indigo-200",
  "Sales Return": "bg-stone-100 text-stone-700 border-stone-200",
};

export function statusClass(status) {
  return STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200";
}

export function ageingBucketColor(days) {
  if (days == null) return "text-slate-500";
  if (days <= 1) return "text-emerald-700 font-medium";
  if (days <= 3) return "text-yellow-700 font-medium";
  if (days <= 7) return "text-orange-700 font-medium";
  if (days <= 15) return "text-rose-700 font-semibold";
  return "text-red-700 font-bold";
}

export const ROLE_LABELS = {
  admin: "System Admin",
  service_head: "Service Head",
  ccr: "Customer Care Rep",
  manager: "Service Manager",
  spares: "Spares Assistant",
  technician: "Technician",
  sales: "Sales Team",
  product_manager: "Product Manager",
  sales_head: "Sales Head",
  sales_manager: "Sales Manager",
  sales_promoter: "Sales Promoter",
  accounts_finance: "Accounts / Finance",
};
